export enum EducationLevel {
  Preschool = 'preschool',
  JuniorElementary = 'juniorElementary',
  SeniorElementary = 'seniorElementary',
  JuniorHigh = 'juniorHigh',
  SeniorHigh = 'seniorHigh',
  Undergraduate = 'undergraduate',
  Graduate = 'graduate',
}

export const EducationLevelDisplayOrder = [
  EducationLevel.Undergraduate,
  EducationLevel.SeniorHigh,
  EducationLevel.JuniorHigh,
  EducationLevel.SeniorElementary,
  EducationLevel.JuniorElementary,
  EducationLevel.Preschool,
  EducationLevel.Graduate,
];

export interface Level {
  label: string;
  icon: string;
}
